import React, { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import api from "../api";

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2100;
  padding: 16px;
`;

const Content = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 360px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.22);
`;

const Title = styled.h3`
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 4px;
  color: #1a5276;
`;

const Sub = styled.p`
  font-size: 13px;
  color: #555;
  margin: 0 0 16px;
`;

const Label = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  margin-bottom: 12px;
  box-sizing: border-box;
  &:focus { outline: none; border-color: #1a5276; }
`;

const BtnRow = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 4px;
`;

const BtnConfirmar = styled.button`
  flex: 1;
  padding: 10px;
  background-color: #1a5276;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  &:disabled { background-color: #95a5a6; cursor: not-allowed; }
  &:hover:not(:disabled) { background-color: #154360; }
`;

const BtnCancelar = styled.button`
  flex: 1;
  padding: 10px;
  background-color: #e0e0e0;
  color: #333;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  &:hover { background-color: #ccc; }
`;

const Aviso = styled.p`
  font-size: 11px;
  color: #999;
  text-align: center;
  margin: 12px 0 0;
  line-height: 1.4;
`;

const ModalLoginCartola = ({ idTime, nomeTime, onClose, onSuccess }) => {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email.trim() || !senha) {
      toast.warn("Preencha e-mail e senha.");
      return;
    }
    setLoading(true);
    try {
      await api.post("Cartola/loginCartola", {
        idTime,
        email: email.trim(),
        password: senha,
      });
      toast.success("Conta Cartola vinculada com sucesso!");
      onSuccess();
      onClose();
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        "Erro ao vincular conta. Verifique as credenciais.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Overlay onClick={onClose}>
      <Content onClick={e => e.stopPropagation()}>
        <Title>🔗 Vincular conta Cartola</Title>
        <Sub>
          Time: <strong>{nomeTime}</strong>
        </Sub>

        <Label>E-mail da conta Globo</Label>
        <Input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="seu@email.com"
          autoFocus
        />

        <Label>Senha</Label>
        <Input
          type="password"
          value={senha}
          onChange={e => setSenha(e.target.value)}
          onKeyDown={e => e.key === "Enter" && handleSubmit()}
          placeholder="Senha da conta Globo"
        />

        <BtnRow>
          <BtnConfirmar onClick={handleSubmit} disabled={loading}>
            {loading ? "Vinculando..." : "Vincular"}
          </BtnConfirmar>
          <BtnCancelar onClick={onClose}>Cancelar</BtnCancelar>
        </BtnRow>

        <Aviso>
          Suas credenciais são enviadas diretamente para a Globo e não são
          armazenadas.
        </Aviso>
      </Content>
    </Overlay>
  );
};

export default ModalLoginCartola;
